import { callExternalApi, CallResult } from '../callExternalApi';
import { AdviseEngagement } from '../../types/advise';

export const uploadAdviseQuote = async (
  engagementId: string,
  formData: FormData
): Promise<CallResult<AdviseEngagement>> => {
  return callExternalApi<AdviseEngagement>({
    url: `api/advise/engagements/${engagementId}/quotes`,
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData
  });
};

export const deleteAdviseQuote = async (
  engagementId: string,
  quoteIndex: number
): Promise<CallResult<AdviseEngagement>> => {
  return callExternalApi<AdviseEngagement>({
    url: `api/advise/engagements/${engagementId}/quotes/${quoteIndex}`,
    method: 'DELETE',
    headers: { 'content-type': 'application/json' }
  });
};

export const updateAdviseLineItems = async (
  engagementId: string,
  lineItemMapping: Record<string, Record<string, string>>,
  telephonyUsageOverrides?: Record<string, { quantity: number; rate: number }>
): Promise<CallResult<AdviseEngagement>> => {
  return callExternalApi<AdviseEngagement>({
    url: `api/advise/engagements/${engagementId}/quotes/line_items`,
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data: { line_item_mapping: lineItemMapping, telephony_usage_overrides: telephonyUsageOverrides }
  });
};
